import { useUserTimeZone } from '@ztechapps/common.hook'
import { formatDate } from '@ztechapps/common.utils'
import type { CommonDateTimeProps } from '../types/CommonDateTimeProps'
import type { SetOptional } from 'type-fest'
import isEmpty from 'lodash/isEmpty'

export type LocalCustomDateTimeProps = SetOptional<CommonDateTimeProps, 'timeZone'>

export const LocalCustomDateTime = ({ value, format, timeZone }: LocalCustomDateTimeProps) => {
  const userTimeZone = useUserTimeZone()
  timeZone = timeZone || userTimeZone

  //if value is null, empty, or undefined, return "--"
  if (isEmpty(value)) return <>--</>

  return <>{formatDate(value, format, timeZone)}</>
}
